
  import classNames from 'classnames'
  import type { ShapeComponentType } from '../types'

  export const Blob05:ShapeComponentType = ({ className, ...props }) => {
    return <svg className={classNames('pintxo-shape', className)} {...props} width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M127.916 63.9995C125.782 103.173 100.342 128 66.5018 128C32.6615 128 17.168 99.2797 2.76788 68.6128C-11.6856 37.7859 33.6748 -11.4412 64.5551 2.39893C98.6887 17.7057 129.836 28.6125 127.916 63.9995Z" fill="#0C0D0D"/>
</svg>

  }
  
